import { Fragment, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MOVE_CANDIDATE, RESET_ACTIVE_CANDIDATE, selectActiveCandidate, selectBallot, selectRemaining } from '../stores/store.js'
import { NameStateful } from './Name.jsx'
import { ZoneStateful } from './Zone.jsx'

export function CondorcetSelector({ remaining, ballot, onPlaceCandidate }) {
  return <div>
    <div className="hstack">
      {Array.from(remaining).sort().map((candidate, i) => <div className="mb-2 mr-2" key={i}>
        <NameStateful name={ candidate } />
      </div>)}
    </div>
    <div className="grid auto-cols-min overflow-y-auto lg:max-h-50vh" style={{gridTemplateColumns: "auto 1fr"}}>
      {ballot.map((row, i) => <Fragment key={i}>
        <div className="bg-gray-800 text-white flex justify-center items-center">
          <div className="flex text-3xl px-6">
            {i+1}
          </div>
        </div>
        <div className="flex-grow">
          <ZoneStateful values={row} key={i} onDrop={onPlaceCandidate.bind(null, i)} onClick={onPlaceCandidate.bind(null, i)} />
        </div>
      </Fragment>)}
    </div>
  </div>
}

export function CondorcetSelectorStateful() {
  const dispatch = useDispatch()

  const remaining = useSelector(selectRemaining)
  const ballot = useSelector(selectBallot)
  const activeCandidate = useSelector(selectActiveCandidate)

  const onPlaceCandidate = useCallback((rowNumber) => {
    const candidate = activeCandidate
    dispatch({ type: MOVE_CANDIDATE, payload: { candidate, to: rowNumber }})
    dispatch({ type: RESET_ACTIVE_CANDIDATE })
  }, [activeCandidate])

  return <CondorcetSelector remaining={remaining} ballot={ballot} onPlaceCandidate={onPlaceCandidate} />
}
